export const DEFAULT_CONCATENATED_SELL_UNIT = 'each of 1'
